import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import {
    EViewMode,
    ISetViewModeAction,
    ISetViewModeForStorageAction,
    QueryParams,
    SettingsState,
} from 'reactApp/modules/settings/settings.types';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';

const initialState: SettingsState = {
    viewMode: EViewMode.list,
    prevViewMode: EViewMode.list,
    viewModePhoto: EViewMode.gallery,
    viewModePhotoMobile: EViewMode.galleryGrid3,
    viewModeAttaches: EViewMode.list,
    viewModeQuotaCleaner: EViewMode.list,
    queryParams: {},
    fromAttaches: false,
};

export const setPhotoViewMode = createAction<ISetViewModeAction>('settings/photoviewmode');
export const setPhotoViewModeMobile = createAction<ISetViewModeAction>('settings/photoviewmodemobile');
export const setAttachesViewMode = createAction<ISetViewModeAction>('settings/attachesviewmode');
export const setFilesViewMode = createAction<ISetViewModeAction>('settings/filesviewmode');
export const setQuotaCleanerViewMode = createAction<ISetViewModeAction>('settings/quotacleanerviewmode');
export const setViewMode = createAction<ISetViewModeForStorageAction>('settings/viewmode');
export const setQueryParams = createAction<QueryParams | undefined>('settings/queryparams');
export const resetQuerySearchParams = createAction('settings/resetQuerySearchParams');
export const loadSettingsRequest = createAction('settings/loadSettingsRequest');
export const setFromAttaches = createAction<boolean>('settings/fromAttaches');

export const settingsReducer = createReducer(initialState, {
    [setPhotoViewMode.type]: (state, action: PayloadAction<ISetViewModeAction>) => {
        const { viewMode } = action.payload;
        state.prevViewMode = state.viewModePhoto;
        state.viewModePhoto = viewMode;
    },
    [setPhotoViewModeMobile.type]: (state, action: PayloadAction<ISetViewModeAction>) => {
        const { viewMode } = action.payload;
        state.prevViewMode = state.viewModePhotoMobile;
        state.viewModePhotoMobile = viewMode;
    },
    [setAttachesViewMode.type]: (state, action: PayloadAction<ISetViewModeAction>) => {
        const { viewMode } = action.payload;
        state.prevViewMode = state.viewModeAttaches;
        state.viewModeAttaches = viewMode;
    },
    [setFilesViewMode.type]: (state, action: PayloadAction<ISetViewModeAction>) => {
        const { viewMode } = action.payload;
        state.prevViewMode = state.viewMode;
        state.viewMode = viewMode;
    },
    [setViewMode.type]: (state, action: PayloadAction<ISetViewModeForStorageAction>) => {
        const { viewMode, storage, isMediaFolder } = action.payload;

        const { isGallery, isAttaches, isQuotaCleaner } = getStorage(storage);
        const isPhone = EnvironmentSelectors.isPhone();

        if ((isGallery || isMediaFolder) && !isPhone) {
            state.prevViewMode = state.viewModePhoto;
            state.viewModePhoto = viewMode;
        } else if (isGallery && isPhone) {
            state.prevViewMode = state.viewModePhotoMobile;
            state.viewModePhotoMobile = viewMode;
        } else if (isAttaches) {
            state.prevViewMode = state.viewModeAttaches;
            state.viewModeAttaches = viewMode;
        } else if (isQuotaCleaner) {
            state.prevViewMode = state.viewModeQuotaCleaner;
            state.viewModeQuotaCleaner = viewMode;
        } else {
            state.prevViewMode = state.viewMode;
            state.viewMode = viewMode;
        }
    },
    [setQueryParams.type]: (state, action: PayloadAction<QueryParams>) => {
        const {
            query,
            folderId,
            type,
            fromAuth,
            weblink,
            sort,
            item,
            action: actionParam,
            id,
            searchType,
            tariffId,
            productId,
            token,
            diskoKey,
            fromCloud,
            from,
            total_size,
            max_size,
        } = action.payload || {};

        state.queryParams = {
            tariffId,
            productId,
            folderId,
            type,
            weblink,
            diskoKey,
            sort,
            item,
            action: actionParam,
            id,
            searchType,
            token,
            from,
            total_size,
            max_size,
            fromCloud: Boolean(fromCloud),
        };

        if (typeof fromAuth === 'boolean') {
            state.queryParams.fromAuth = Boolean(fromAuth);
        }
        if (typeof query !== 'undefined') {
            state.queryParams.query = query;
        }
    },
    [resetQuerySearchParams.type]: (state) => {
        delete state.queryParams.query;
        delete state.queryParams.fromAuth;
        delete state.queryParams.folderId;
    },
    [setFromAttaches.type]: (state, action: PayloadAction<boolean>) => {
        state.fromAttaches = action.payload;
    },
    [setFromAttaches.type]: (state, action: PayloadAction<boolean>) => {
        state.fromAttaches = action.payload;
    },
});
